import CreateTransferFromRequestModal from './CreateTransferFromRequestModal'
import { ActionModalType } from '../../../../components/ActionModal'
import { heapEvent } from '@equipmentshare/heaper'
import { LineItem } from '../../../../types/demandRequest'

export type CreateTransferFromRequestModalData = {
	fromInventoryId: number,
	toInventoryId: number,
	selectedLineItems: LineItem[],
	requestId: string,
	requestNumber: number,
	onTransferSuccess?: ( fullyFulfilledLineItemIds: string[], transactionId?: number ) => void,
}

export function getCreateTransferFromRequestModal(
	data: CreateTransferFromRequestModalData
): ActionModalType {
	return {
		component: CreateTransferFromRequestModal,
		label: 'Create Transfer',
		width: 700,
		componentProps: data,
		onXClick: () => heapEvent( 'Inventory - Stock Request - Create Transfer Modal - Click - X', {
			demand_request_id: data.requestId,
		} ),
	}
}
